import React from 'react';
import { types_dict } from '../static/types_dictionary';

const designType = (one) => one?.avatar?.design?.type || one?.design?.type;

export function ListTypes(props) {
  const {
    array = [],
    active = null,
    onSelect = () => {},
    types = ['G', 'MG', 'M', 'P', 'R'],
  } = { ...props };

  const countFor = (oneType) => array.filter((one) => designType(one) === oneType).length;

  const handleClick = (oneType) => {
    onSelect(active === oneType ? null : oneType);
  };

  return (
    <>
      <div className="x_choose_list_scroll">

        <div className="x_choose_list mobile_v_no">
          {types.map(oneType => {
            const isActive = active === oneType;
            const isIdle = active && !isActive;
            const count = countFor(oneType);
            return (<div
              key={`person_${oneType}_top_menu`}
              onClick={() => handleClick(oneType)}
            >
              <div
                className={[
                  'x_choose_menu_but',
                  count === 0 && 'x_choose_menu_but--0',
                  isActive && 'active',
                  isIdle && 'idle',
                ].filter(Boolean).join(' ')}
              >
                {types_dict[oneType]['titlePlural']}
                <div className="x_choose_menu_counter">
                  {count}
                </div>
              </div>
            </div>)
          })}
        </div>

        <div className="x_choose_list mobile_v_yes">
          {types.map(oneType => {
            const isActive = active === oneType;
            const isIdle = active && !isActive;
            const count = countFor(oneType);
            return (<div
              key={`person_${oneType}_top_menu_m`}
              className={[
                'x_choose_menu_but',
                count === 0 && 'x_choose_menu_but--0',
                isActive && 'active',
                isIdle && 'idle',
              ].filter(Boolean).join(' ')}
              onClick={() => handleClick(oneType)}
            >
              {types_dict[oneType]['titleXsPlural']}
              <div className="x_choose_menu_counter">
                {count}
              </div>

            </div>)
          })}
        </div>



      </div>
    </>
  )
}